import { useState } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../routes/path";
import HCaptcha from "@hcaptcha/react-hcaptcha";

function ServiceList(props) {
  const [captchaToken, setCaptchaToken] = useState("");
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [messageObj, setMessageObj] = useState({
    show: false,
    class: "",
    message: "",
  });

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!captchaToken) {
      setMessageObj({
        show: true,
        class: "error text-danger mt-3",
        message: "Please complete the captcha first.",
      });
      return;
    }
    setDisableSubmitBtn(true);

    const formData = new FormData(event.target);
    formData.append("h-captcha-response", captchaToken);
    formData.append("access_key", process.env.REACT_APP_WEB3FORMS_CONTACT_KEY);

    // const object = Object.fromEntries(formData);

    try {
      const response = await fetch(ROUTES.WEB3FORMS_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(Object.fromEntries(formData)),
      });

      let data = await response.json();

      if (!data["success"]) {
        throw new Error(
          data["message"] || "Oops! Your message could not be sent.",
        );
      }

      setMessageObj({
        show: true,
        class: "success text-success mt-3",
        message: "Thank you! Your message has been sent.",
      });
    } catch (e) {
      setMessageObj({
        show: true,
        class: "error text-danger mt-3",
        message: e?.message || "Oops! Your message could not be sent.",
      });
    } finally {
      setDisableSubmitBtn(false);
    }
  };

  return (
    <div className="site-wrapper-reveal">
      <div className="bg-white">
        <div
          className="about-banner-wrap banner-space bg-img"
          data-bg="/assets/images/hero/itsolution-banner.png"
          style={{
            backgroundImage: "url(/assets/images/hero/itsolution-banner.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto">
                <div className="about-banner-content text-center">
                  <h1 className="mb-15 text-white">Business solution</h1>
                  <h5 className="font-weight--normal text-white">
                    Reach out to the world’s most reliable IT services.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===========  feature-large-images-wrapper  Start =============--> */}
        <div className="feature-large-images-wrapper section-space--ptb_100">
          <div className="container">
            <div className="cybersecurity-about-box">
              <div className="row">
                <div className="col-lg-4">
                  <div className="conact-us-wrap-one managed-it">
                    <h5 className="heading ">
                      Global Tech - 9 specializes in{" "}
                      <span className="text-color-primary">
                        {" "}
                        technological and IT-related services
                      </span>{" "}
                      such as product engineering, warranty management, building
                      cloud, infrastructure, network, etc.{" "}
                    </h5>
                  </div>
                </div>
                <div className="col-lg-7 offset-lg-1">
                  <div className="cybersecurity-about-text">
                    <div className="text">
                      The IT services that Global Tech - 9 are running can be
                      segmented by the type of skills employed to deliver the
                      service (design, build, run). Technically, these fall into
                      three main categories: business process services,
                      application services, and infrastructure services.
                    </div>
                    <div className="button-group-wrap">
                      <Link
                        to={ROUTES.CONTACT}
                        className="ht-btn ht-btn-md ht-btn--solid me-md-3"
                      >
                        Contact Us
                      </Link>
                      <Link to="" className="ht-btn ht-btn-md ht-btn--solid">
                        Live chat with a consultant
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===========  feature-large-images-wrapper  End =============--> */}

        {/* <!--===========  feature-images-wrapper  Start =============--> */}
        <div className="feature-images-wrapper bg-gray section-space--ptb_100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <!-- section-title-wrap Start --> */}
                <div className="section-title-wrap text-center section-space--mb_30">
                  <h3 className="heading">
                    Reliable IT Services for{" "}
                    <span className="text-color-primary"> Businesses</span>
                  </h3>
                </div>
                {/* <!-- section-title-wrap Start --> */}
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="feature-images__four">
                  <div className=" row">
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-01-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">Cloud Computing</h5>
                            <div className="text">
                              We provide the most responsive and functional IT
                              design for companies and businesses worldwide.
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-02-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">Video Analytics </h5>
                            <div className="text">
                              It’s possible to simultaneously manage and
                              transform information from one server to another.
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-03-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">Autonomous Robotics</h5>
                            <div className="text">
                              Back up your database, store in a safe and secure
                              place while still maintaining its accessibility.
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-04-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">Cyber Security</h5>
                            <div className="text">
                              Suspe ndisse suscipit sagittis leo sit met condime
                              ntum esti laiolainx bulum iscipit sagittis leo sit
                              met con ndisse suscipit sagittis leo sit met cone
                              su
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-05-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">IT Consultancy</h5>
                            <div className="text">
                              We provide the most responsive and functional IT
                              design for companies and businesses worldwide.
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                    <div className="single-item col-lg-4 col-md-6 mt-30 wow move-up">
                      {/* <!-- ht-box-icon Start --> */}
                      <Link to="#" className="ht-box-images style-04">
                        <div className="image-box-wrap">
                          <div className="box-image">
                            <img
                              className="img-fulid"
                              src="/assets/images/icons/mitech-box-image-style-05-image-06-60x60.webp"
                              alt=""
                            />
                          </div>
                          <div className="content">
                            <h5 className="heading">Cyber Security</h5>
                            <div className="text">
                              Global Tech - 9 takes into account all conditions
                              and budgets needed for building infrastructure
                              plan..
                            </div>
                          </div>
                        </div>
                      </Link>
                      {/* <!-- ht-box-icon End --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===========  feature-images-wrapper  End =============--> */}

        {/* <!--========= About Delivering Wrapper Start ===========--> */}
        <div className="about-delivering-wrapper section-space--ptb_100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-wrap text-center section-space--mb_20">
                  <h3 className="heading">Business IT Support Features</h3>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="delivering-optimal-wrap">
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title">Cloud Computing </h5>
                      <div className="desc">
                        We provide the most responsive and functional Cloud
                        Computing for companies and businesses worldwide.{" "}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title"> Autonomous Robotics </h5>
                      <div className="desc">
                        Back up your database, store in a safe and secure place
                        while still maintaining its accessibility.{" "}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title">Cyber Security </h5>
                      <div className="desc">
                        Global Tech - 9 takes into account all conditions and
                        budgets needed for building Cyber Security.{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="delivering-optimal-wrap">
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title">Video Analytics </h5>
                      <div className="desc">
                        It’s possible to simultaneously manage and transform key
                        information from one server to another.{" "}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title">IT Consultancy</h5>
                      <div className="desc">
                        We propose feasible & practical plans for successfully
                        transform businesses based on their needs.{" "}
                      </div>
                    </div>
                  </div>
                  <div className="list-item">
                    <div className="marker"></div>
                    <div className="title-wrap">
                      <h5 className="title">Firewall Advancement </h5>
                      <div className="desc">
                        Enhancing the strength and security of firewalls to
                        protect online data from malicious sources.{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--========= About Resources Wrapper Start ===========--> */}
        <div className="about-resources-wrapper">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <div className="resources-left-box">
                  <div className="resources-inner">
                    <h6 className="sub-title mb-20">Resources</h6>
                    <h3 className="heading">
                      Get a copy of brochure on{" "}
                      <span className="text-color-primary">
                        {" "}
                        Brand New IT Tech.
                      </span>
                    </h3>
                    <div className="button mt-30">
                      <a
                        href="/gt9_brochure.pdf"
                        className="ht-btn ht-btn-md"
                        download="GT9 Brochure.pdf"
                      >
                        Download now (4Mb)
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="resources-right-box">
                  <div className="resources-right-inner text-center">
                    <div className="resources-images">
                      <img
                        className="img-fluid"
                        src="/assets/images/banners/managed-it-services-book-cover.webp"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--========= About Resources Wrapper End ===========--> */}
        {/* <!--====================  testimonial section ====================--> */}
        <div className="testimonial-slider-area section-space--pt_100">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-wrap text-center section-space--mb_40">
                  <h6 className="section-sub-title mb-20">Testimonials</h6>
                  <h3 className="heading">
                    What do people praise about{" "}
                    <span className="text-color-primary">
                      {" "}
                      Global Tech - 9?
                    </span>
                  </h3>
                </div>
                <div className="testimonial-slider">
                  <div className="swiper-container testimonial-slider__container">
                    <div className="swiper-wrapper testimonial-slider__wrapper">
                      <div className="swiper-slide">
                        <div className="testimonial-slider__one wow move-up">
                          <div className="testimonial-slider--info">
                            <div className="testimonial-slider__media">
                              <img
                                src="/assets/images/testimonial/Global Tech - 9-testimonial-avata-02-90x90.webp"
                                className="img-fluid"
                                alt=""
                              />
                            </div>

                            <div className="testimonial-slider__author">
                              <div className="testimonial-rating">
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                              </div>
                              <div className="author-info">
                                <h6 className="name">Abbie Ferguson</h6>
                                <span className="designation">Marketing</span>
                              </div>
                            </div>
                          </div>

                          <div className="testimonial-slider__text">
                            I’ve been working with over 35 IT companies on more
                            than 200 projects of our company, but @Global Tech -
                            9 is one of the most impressive to me.
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="testimonial-slider__one wow move-up">
                          <div className="testimonial-slider--info">
                            <div className="testimonial-slider__media">
                              <img
                                src="/assets/images/testimonial/Global Tech - 9-testimonial-avata-03-90x90.webp"
                                className="img-fluid"
                                alt=""
                              />
                            </div>

                            <div className="testimonial-slider__author">
                              <div className="testimonial-rating">
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                              </div>
                              <div className="author-info">
                                <h6 className="name">Monica Blews</h6>
                                <span className="designation">
                                  Web designer
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="testimonial-slider__text">
                            I’ve been working with over 35 IT companies on more
                            than 200 projects of our company, but @Global Tech -
                            9 is one of the most impressive to me.
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="testimonial-slider__one wow move-up">
                          <div className="testimonial-slider--info">
                            <div className="testimonial-slider__media">
                              <img
                                src="/assets/images/testimonial/Global Tech - 9-testimonial-avata-04-90x90.webp"
                                className="img-fluid"
                                alt=""
                              />
                            </div>

                            <div className="testimonial-slider__author">
                              <div className="testimonial-rating">
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                              </div>
                              <div className="author-info">
                                <h6 className="name">Abbie Ferguson</h6>
                                <span className="designation">
                                  WEB DESIGNER
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="testimonial-slider__text">
                            I’ve been working with over 35 IT companies on more
                            than 200 projects of our company, but @Global Tech -
                            9 is one of the most impressive to me.
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="testimonial-slider__one wow move-up">
                          <div className="testimonial-slider--info">
                            <div className="testimonial-slider__media">
                              <img
                                src="/assets/images/testimonial/Global Tech - 9-testimonial-avata-01-90x90.webp"
                                className="img-fluid"
                                alt=""
                              />
                            </div>

                            <div className="testimonial-slider__author">
                              <div className="testimonial-rating">
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                                <span className="fa fa-star"></span>
                              </div>
                              <div className="author-info">
                                <h6 className="name">Abbie Ferguson</h6>
                                <span className="designation">
                                  WEB DESIGNER
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="testimonial-slider__text">
                            I’ve been working with over 35 IT companies on more
                            than 200 projects of our company, but @Global Tech -
                            9 is one of the most impressive to me.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="swiper-pagination swiper-pagination-t01 section-space--mt_30"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--====================  End of testimonial section  ====================--> */}

        {/* <!--====================  brand logo slider area ====================--> */}
        <div className="brand-logo-slider-area section-space--ptb_60">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <!-- brand logo slider --> */}
                <div className="brand-logo-slider__container-area">
                  <div className="swiper-container brand-logo-slider__container">
                    <div className="swiper-wrapper brand-logo-slider__one">
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-01.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-01-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-02.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-02-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-03.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-03-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-04.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-04-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-05.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-05-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-06.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-06-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-07.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-07-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-08.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-08-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                      <div className="swiper-slide brand-logo brand-logo--slider">
                        <Link to="#">
                          <div className="brand-logo__image">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-09.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="brand-logo__image-hover">
                            <img
                              src="/assets/images/brand/Global Tech - 9-client-logo-09-hover.webp"
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--====================  End of brand logo slider area  ====================--> */}
        {/* <!--============ Contact Us Area Start =================--> */}
        <div className="contact-us-area service-contact-bg section-space--ptb_100">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-4 me-auto">
                <div className="contact-info sytle-one text-left">
                  <div className="contact-info-title-wrap text-center">
                    <h3 className="heading text-white mb-10">4.9/5.0</h3>
                    <div className="ht-star-rating lg-style">
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                      <span className="fa fa-star"></span>
                    </div>
                    <p className="sub-text">
                      by 100+ customers across 200+ projects
                    </p>
                  </div>

                  <div className="contact-list-item">
                    <Link to="tel:190068668" className="single-contact-list">
                      <div className="content-wrap">
                        <div className="content">
                          <div className="icon">
                            <span className="fas fa-phone"></span>
                          </div>
                          <div className="main-content">
                            <h6 className="heading">Call for advice now!</h6>
                            <div className="text">79773 - 53388</div>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <Link
                      to="mailto:contact@globaltech.com"
                      className="single-contact-list"
                    >
                      <div className="content-wrap">
                        <div className="content">
                          <div className="icon">
                            <span className="far fa-envelope"></span>
                          </div>
                          <div className="main-content">
                            <h6 className="heading">Say hello</h6>
                            <div className="text">contact@globaltech.com</div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-5 me-auto ms-auto">
                <div className="business-solution-form-wrap">
                  <div className="contact-title text-center section-space--mb_40">
                    <h5 className="mb-10">Book appointment</h5>
                    <p className="text">
                      It's out pleasure to have a chance to cooperate.
                    </p>
                  </div>

                  <form id="contact-form" onSubmit={onSubmit}>
                    <div className="contact-form__two">
                      <div className="contact-input">
                        <div className="contact-inner">
                          <input
                            name="name"
                            type="text"
                            placeholder="Name *"
                            required
                          />
                        </div>
                        <div className="contact-inner">
                          <input
                            name="email"
                            type="email"
                            placeholder="Email *"
                            required
                          />
                        </div>
                      </div>
                      <div className="contact-select">
                        <div className="form-item contact-inner">
                          <span className="inquiry">
                            <select
                              id="department"
                              name="subject"
                              defaultValue=""
                              required
                            >
                              <option value="" disabled>
                                Select Department to email
                              </option>
                              <option value="General Information Request">
                                General Information Request
                              </option>
                              <option value="Partner Relations">
                                Business Solution
                              </option>
                              <option value="Software Licensing">
                                Software Licensing
                              </option>
                              <option value="Pricing">Partner Relations</option>
                            </select>
                          </span>
                        </div>
                      </div>
                      <div className="contact-inner contact-message">
                        <textarea
                          name="message"
                          placeholder="Please describe what you need."
                          required
                        ></textarea>
                      </div>

                      <HCaptcha
                        sitekey={process.env.REACT_APP_HCAPTCHA_KEY}
                        reCaptchaCompat={false}
                        onVerify={setCaptchaToken}
                      />

                      <div className="comment-submit-btn">
                        <button
                          className="ht-btn ht-btn-md"
                          type="submit"
                          disabled={disableSubmitBtn}
                        >
                          Get a free consultation
                        </button>

                        {messageObj["show"] && (
                          <p className={`form-messege ${messageObj["class"]}`}>
                            {messageObj["message"]}
                          </p>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--============ Contact Us Area End =================--> */}
      </div>
    </div>
  );
}

export default ServiceList;
